import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminApp from './AdminApp';
import axios from 'axios';

axios.defaults.withCredentials = true;


const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if we're on admin route
const isAdminRoute = window.location.pathname.startsWith('/admin');

root.render(
  <React.StrictMode>
    {isAdminRoute ? <AdminApp /> : <App />}
  </React.StrictMode>
);